if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.form.addEventListener('click', this.onBuyNowClick.bind(this), true);
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        this.hideErrors = this.dataset.hideErrors === 'true';
        window.addEventListener('pageshow', (event) => {
          if (event.persisted && this.isConnected) {
            this.navigationPending = false;
            this.confirmationUncertain = false;
            this.releaseSubmission();
          }
        });
      }

      onBuyNowClick(event) {
        const button = event.target.closest('.shopify-payment-button__button--unbranded');
        if (!button) return;
        if (window.yeverCheckoutBusy || this.requestPending || this.confirmationUncertain) {
          event.preventDefault();
          event.stopImmediatePropagation();
          if (this.confirmationUncertain) this.navigateToCart();
          return;
        }
        if (typeof window.buyProduct === 'function') {
          event.preventDefault();
          event.stopImmediatePropagation();
          window.buyProduct.call(button, event);
        }
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        if (window.yeverCheckoutBusy) return;
        // An interrupted response can still represent a committed cart write.
        // Inspect the cart instead of submitting the same item a second time.
        if (this.confirmationUncertain) { this.navigateToCart(); return; }
        if (this.requestPending || this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();
        this.requestPending = true;
        this.submitButton.setAttribute('aria-disabled', 'true');
        this.submitButton.setAttribute('aria-busy', 'true');
        this.submitButton.classList.add('loading');
        const spinner = this.submitButton.querySelector('.loading__spinner');
        spinner?.classList.remove('hidden');
        this.setProgress('Adicionando ao carrinho…');
        const controller = new AbortController();
        const slowTimer = setTimeout(() => this.setProgress('Ainda estamos confirmando. Não é necessário clicar novamente.'), 6000);
        const timeout = setTimeout(() => controller.abort(), 12000);
        let confirmed = false;
        try {
          const config = fetchConfig('javascript');
          config.headers['X-Requested-With'] = 'XMLHttpRequest';
          delete config.headers['Content-Type'];
          const formData = new FormData(this.form);
          config.body = formData;
          config.signal = controller.signal;
          const cartAddUrl = routes.cart_add_url.replace(/\/add(?:\.js)?$/, '/add.js');
          const result = await fetch(cartAddUrl, config);
          const response = await result.json().catch(() => null);
          if (!result.ok || response?.status) {
            if (result.status >= 500 || result.status === 408) throw new Error('Resposta do carrinho indisponível');
            if (!response) {
              this.handleErrorMessage('A loja não aceitou esta tentativa. Aguarde um momento antes de tentar novamente.');
              this.setProgress('Não foi possível adicionar o produto nesta tentativa.');
              return;
            }
            this.handleErrorMessage(response.description || window.cartStrings.error);
            this.setProgress('Não foi possível adicionar. Confira a mensagem acima antes de tentar novamente.');
            if (typeof publish === 'function') {
              try { Promise.resolve(publish(PUB_SUB_EVENTS.cartError, { source: 'product-form', productVariantId: formData.get('id'), errors: response.errors || response.description, message: response.message })).catch(console.error); } catch (error) { console.error(error); }
            }
            return;
          }
          if (!response || (!response.id && !response.items)) throw new Error('Resposta de adição inválida');
          confirmed = true;
          if (this.cart && typeof publish === 'function') {
            try { Promise.resolve(publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id'), cartData: response })).catch(console.error); } catch (error) { console.error(error); }
          }
          this.setProgress('Produto adicionado. Abrindo seu carrinho…', true);
          this.navigateToCart();
          return;
        } catch (error) {
          console.error(error);
          this.confirmationUncertain = !confirmed;
          this.setProgress(confirmed ? 'Produto adicionado. Acesse seu carrinho para continuar.' : 'Não foi possível confirmar a adição. Confira seu carrinho antes de tentar novamente.', true);
          // The server may have accepted the product before the connection failed.
          // Navigation is read-only and preserves quantity and engraving.
          try { this.navigateToCart(); } catch (navigationError) { console.error(navigationError); }
        } finally {
          clearTimeout(slowTimer);
          clearTimeout(timeout);
          if (!this.navigationPending) {
            this.releaseSubmission();
          }
        }
      }

      releaseSubmission() {
        this.submitButton.classList.remove('loading');
        this.submitButton.removeAttribute('aria-busy');
        this.submitButton.querySelector('.loading__spinner')?.classList.add('hidden');
        this.requestPending = false;
        this.submitButton.removeAttribute('aria-disabled');
      }

      navigateToCart() {
        this.navigationPending = true;
        try { window.location.assign(window.routes.cart_url); }
        catch (error) { this.navigationPending = false; throw error; }
      }

      setProgress(message, cartLink = false) {
        if (!this.progressMessage) {
          this.progressMessage = document.createElement('p');
          this.progressMessage.className = 'product-form__status caption-large';
          this.progressMessage.setAttribute('role', 'status');
          this.progressMessage.setAttribute('aria-live', 'polite');
          this.form.after(this.progressMessage);
        }
        this.progressMessage.textContent = message;
        if (cartLink) {
          const link = document.createElement('a');
          link.href = window.routes.cart_url;
          link.textContent = ' Ver carrinho';
          this.progressMessage.append(link);
        }
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
